import { configPublic } from '@src/config.public'
import type { LocaleConfig } from '@src/i18n/locales'
import {
  isExternalShopifyLink,
  shopifyTextRegex,
  shopifyTextReplacer,
  transformExternalShopifyLink,
} from '@src/utils/externalShopifyLink'

const TBB = 'teambeachbody.com'
const BOD = 'beachbodyondemand.com'
const BB = 'beachbody.com'
const DEFAULT_ORIGIN = 'https://bodi.com'

// TODO: remove temporary shop.* to bodi.com hostname rewrite
const SHOP_TO_BODI_HOSTNAME_MAP: Record<string, string> = {
  'shop.bodi.com': 'www.bodi.com',
  'shop-us.qa.bodi.com': 'qa.bodi.com',
  'shop-us.stage.bodi.com': 'stage.bodi.com',
}
export const isExternalBODiLink = (href: string) => {
  const url = new URL(href, globalThis.location?.origin ?? DEFAULT_ORIGIN)
  return (
    [TBB, BB, BOD].some(
      (hostname) => url.hostname === hostname || url.hostname.endsWith(`.${hostname}`)
    ) || isExternalShopifyLink(url.hostname)
  )
}

export const transformExternalBODiLinkInText = (text: string) => {
  const tbbRegex = new RegExp(`https?://(?:www\\.)?${TBB}`, 'i')
  const bodRegex = new RegExp(`https?://(?:www\\.)?${BOD}`, 'i')
  const bbRegex = new RegExp(`https?://(?:www\\.)?${BB}`, 'i')

  return text
    .replace(tbbRegex, configPublic.general.tbbUrl)
    .replace(bodRegex, configPublic.general.bodUrl)
    .replace(bbRegex, configPublic.general.beachbodyUrl)
    .replace(shopifyTextRegex, shopifyTextReplacer)
}

export const transformExternalBODiLink = (href: string, locale?: LocaleConfig) => {
  const tbbUrl = new URL(configPublic.general.tbbUrl)
  const bodUrl = new URL(configPublic.general.bodUrl)
  const beachbodyUrl = new URL(configPublic.general.beachbodyUrl)

  const url = new URL(href, globalThis.location?.origin ?? DEFAULT_ORIGIN)

  if (url.hostname === TBB || url.hostname.endsWith(`.${TBB}`) || url.hostname.includes('tbb')) {
    url.hostname = tbbUrl.hostname
  } else if (url.hostname === BOD || url.hostname.endsWith(`.${BOD}`)) {
    url.hostname = bodUrl.hostname
    if (locale) {
      url.searchParams.set('locale', locale.codeSnakeCase)
    }
  } else if (url.hostname === BB || url.hostname.endsWith(`.${BB}`)) {
    url.hostname = beachbodyUrl.hostname
  } else {
    transformExternalShopifyLink(url, locale)

    if (configPublic.featureFlags.onesiteP2Enabled) {
      const mapped = SHOP_TO_BODI_HOSTNAME_MAP[url.hostname.toLowerCase()]
      if (mapped) url.hostname = mapped
    }
  }

  return url.toString()
}
